function isMatch(needle, haystack) {
    // Split the search string on on whitespace. Require each word to
    // appear in the haystack in the same order as the search string.

    var searchRegex = needle.split(/\s+/).map(regexEscape).join('.+');

    return !!haystack.match(new RegExp(searchRegex, 'i'));
}

function regexEscape(s) {
    return s.replace(/\W/g, '\\$&');
}

module.exports = {
    isMatch
};



// WEBPACK FOOTER //
// ./app/util/Search.js